import { Deserializable } from '../../protocols/deserializable';
import { LookAheadItem } from '../../../views/shared/components/search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';
import { BaseUser } from '../../base/base-user';
import { Address } from './address';
import * as moment from 'moment/moment';
import { PronounTypeEnum } from '../enum/pronoun-type.enum';
import { MemberRecordComment } from '../../../views/records/components/members/ip-member-record/member-record-comments/member-record-comment';
import { MemberAccount } from '../../transactions/member-account';
import { GenderTypeEnum } from '../enum/gender-type';
import { Gender } from './gender';
import { MfaType } from '../../types/dto/mfa-type';
import { EmploymentHistory } from './employment-history';
import { MostRecentInvite } from './most-recent-invite';
import { Pronoun } from './pronoun';
import { MemberRecord } from './member-record';
import { MemberRelationshipStatus } from './member-relationship-status';
import { BankAccount } from '../../../views/banking/models/bank-account';
import { Fiduciary } from '../../../views/fiduciaries/models/fiduciary';
import { MemberStatusType } from './member-status-type';
import { MemberStatusTypeEnum } from '../enum/member-status-type-enum';
import { StatusPill } from '../../shared/status-pill';
import { MemberStatusUtils } from '../../../utils/member-status-utils';

export class MemberUser extends BaseUser implements Deserializable, LookAheadItem {
  public birthDate!: string;
  public accounts: MemberAccount[] = [];
  public genderId!: GenderTypeEnum;
  public gender!: Gender;
  public middleName!: string;
  public primaryPhoneNumber!: string;
  public primaryPhoneNumberCountryCode!: string;
  public secondaryPhoneNumber!: string;
  public secondaryPhoneNumberCountryCode!: string;
  public socialInsuranceNumber!: string;
  public preferredName!: string;
  public deathDate!: string | null;
  public contactInformationConfirmed!: boolean;
  public federalResident!: boolean;
  public employmentHistory!: EmploymentHistory[];
  public pronoun!: Pronoun | null;
  public pronounId!: PronounTypeEnum | null;
  public comments!: MemberRecordComment[];
  public mfaTypeId!: number;
  public mfaType!: MfaType;
  public mostRecentInvite!: MostRecentInvite;
  public relationshipStatus!: MemberRelationshipStatus;
  public bankAccounts!: BankAccount[];
  public legalFiduciary!: Fiduciary | null;
  public statusId!: MemberStatusTypeEnum;
  public status!: MemberStatusType;

  // Not From API
  public formattedBirthDate!: string;
  public mfaActive!: boolean;
  public statusPill!: StatusPill;

  public onDeserialize() {
    super.onDeserialize();
    this.statusPill = MemberStatusUtils.statusPill(this.statusId);
    if (!!this.status) {
      this.status = window?.injector?.Deserialize?.instanceOf(MemberStatusType, this.status);
    }
    if (!!this.address) {
      this.address = window?.injector?.Deserialize?.instanceOf(Address, this.address);
    }
    if (!!this.employmentHistory) {
      this.employmentHistory = window?.injector?.Deserialize?.arrayOf(EmploymentHistory, this.employmentHistory);
    }
    if (!!this.birthDate) {
      const date = moment(this.birthDate.toString().split('T')[0]);
      this.formattedBirthDate = date.format('DD / MM / YYYY');
    }
    if (!!this.accounts) {
      this.accounts = window?.injector?.Deserialize?.arrayOf(MemberAccount, this.accounts);
    }
    if (this.mfaTypeId !== 3) {
      this.mfaActive = true;
    }
    if (!!this.mostRecentInvite) {
      this.mostRecentInvite = window?.injector?.Deserialize?.instanceOf(MostRecentInvite, this.mostRecentInvite);
    }
    if (!!this.relationshipStatus) {
      this.relationshipStatus = window?.injector?.Deserialize?.instanceOf(
        MemberRelationshipStatus,
        this.relationshipStatus
      );
    }
    if (!!this.bankAccounts) {
      this.bankAccounts = window?.injector?.Deserialize?.arrayOf(BankAccount, this.bankAccounts);
    }
    if (!!this.legalFiduciary) {
      this.legalFiduciary = window.injector.Deserialize.instanceOf(Fiduciary, this.legalFiduciary);
    }
  }

  // TODO: Temp method to populate member user from member record, until all endpoints are updated to use member record
  public populateMemberUserFromMemberRecord(record: MemberRecord): void {
    this.id = record.id;
    this.firstName = record.firstName;
    this.lastName = record.lastName;
    this.preferredName = record.preferredName;
    this.middleName = record.middleName;
    this.preferredName = record.preferredName;
    this.address = record.address;
    if (!!record?.personalInformation) {
      this.birthDate = record?.personalInformation?.birthDate;
      this.socialInsuranceNumber = record?.personalInformation?.socialInsuranceNumber;
      this.pronounId = record?.personalInformation?.pronounId;
      this.pronoun = record?.personalInformation?.pronoun;
      this.genderId = record?.personalInformation?.genderId;
      this.gender = record?.personalInformation?.gender;
      this.formattedBirthDate = record?.personalInformation?.formattedBirthDate;
    }
    if (!!record?.phoneNumber) {
      this.primaryPhoneNumber = record?.phoneNumber?.primaryPhoneNumber ?? '';
      this.primaryPhoneNumberCountryCode = record?.phoneNumber?.primaryPhoneNumberCountryCode ?? '';
      this.secondaryPhoneNumber = record?.phoneNumber?.secondaryPhoneNumber ?? '';
      this.secondaryPhoneNumberCountryCode = record?.phoneNumber?.secondaryPhoneNumberCountryCode ?? '';
    }
    if (!!record.activeRelationshipStatus) {
      this.relationshipStatus = record.activeRelationshipStatus;
    }
    if (!!record.activeLegalFiduciary) {
      this.legalFiduciary = record.activeLegalFiduciary;
    }
    if (record.accounts) {
      this.accounts = record.accounts;
    }
    this.statusId = record.statusId;
    this.status = record.status;
    this.statusPill = record.statusPill;
  }

  // Look ahead item interface

  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return 'disabled';
  }
}
